import React from 'react';
import { InfoIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { contexts } from '../data/content';
export function ForWhom() {
  return <section className="w-full bg-plum-50 py-16 md:py-24" data-id="element-89" data-mp="33hugi1ix5xz2">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-90" data-mp="33idxng0qwic1">
        <SectionHeading eyebrow="Para quién es" title={<>
              ¿Para quién es <span className="italic text-gold-700" data-id="element-92" data-mp="3wy5irfrp1">El Puente del Adiós</span>?
            </>} intro={<p data-id="element-93" data-mp="3r7yglywwfflb">
              Material de apoyo para quienes acompañan a niños y adolescentes atravesando una
              pérdida. Puede utilizarse como recurso complementario en:
            </p>} data-id="element-91" data-mp="2yjkkxpta8vcx" />

        <ul className="mx-auto mt-10 flex max-w-3xl flex-wrap justify-center gap-3" data-id="element-94" data-mp="3hfiy90howozw">
          {contexts.map(context => <li key={context} className="rounded-full bg-white px-5 py-2.5 font-semibold text-plum-700 ring-1 ring-plum-200" data-id="element-95" data-mp="e16jejdo340h">
              {context}
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-center text-lg leading-relaxed text-ink" data-id="element-96" data-mp="1t4rnvjkkdits">
          El objetivo: recursos organizados para facilitar expresión, reflexión y conversación.
        </p>

        <div className="mx-auto mt-8 flex max-w-2xl gap-4 rounded-xl border-l-4 border-teal-500 bg-teal-50 px-5 py-5" data-id="element-97" data-mp="1kcgaozegnrvr">
          <InfoIcon className="mt-0.5 h-5 w-5 shrink-0 text-teal-600" aria-hidden="true" data-id="element-98" data-mp="15f5rf3vkthph" />
          <p className="leading-relaxed text-ink" data-id="element-99" data-mp="1ah4u0bjhsald">
            No reemplaza una evaluación ni un tratamiento profesional cuando estos son necesarios.
          </p>
        </div>
      </div>
    </section>;
}